export default "__VITE_IMAGE_ASSET__9c1a05e7__";